require('../css/embed/crowdfunding.css')
require('../css/embed/flipdown.css')
import FlipDown from '../js/flipdown'

document.addEventListener('DOMContentLoaded', () => {
    const date = parseInt(document.getElementById('flipdown').dataset.date);
    new FlipDown(date, {
        headings: ["Dni", "Godzin", "Minut", "Sekund"]
    }).start();
})
